<template>

  <div class="wrapper">
    <HeaderComponent />
    <main class="main">
      <div class="container">
        <div
          v-if="!showSuccessMessage"
          class="quiz-end"
        >
          <div class="quiz-end-top">
            <div class="quiz-end-top__img">
              <img src="/static/img/game-end.svg" alt="зоозавр">
            </div>
            <h2 class="quiz-end-top__title">Поздравляем!</h2>
            <h3 class="quiz-end-top__accent">Теперь Вы - ответственный владелец!</h3>
            <p class="quiz-end-top__text">Пожалуйста, оставьте свои контактные данные, чтобы мы могли отправить Вам Сертификат ответственного владельца и промокод для выгодных покупок в сети Зоозавр. Ознакомиться по списком адресов магазинов можно по ссылке <a href="https://zoozavr.ru/shops/" class="accent">https://zoozavr.ru/shops/</a>.</p>
          </div>
          <div class="quiz-end-form">
            <form class="form">
              <label class="form__label" :class="{ 'error': nameError }">
                <span class="form__text">Имя*</span>
                <input
                  id="userName"
                  v-model="userName"
                  type="text"
                  required
                  placeholder="Имя"
                  class="form__input"
                  :class="{ 'error': nameError }"
                  @blur="validateNameOnBlur"
                >
                <span
                  v-if="nameError"
                  class="error__message"
                >
                {{ nameError }}
              </span>
              </label>
              <label class="form__label" :class="{ 'error': emailError }">
                <span class="form__text">E-mail*</span>
                <input
                  id="userEmail"
                  v-model="userEmail"
                  type="email"
                  required
                  placeholder="E-mail"
                  class="form__input"
                  :class="{ 'error': emailError }"
                  @blur="validateEmailOnBlur"
                >
                <span
                  v-if="emailError"
                  class="error__message"
                >
                {{ emailError }}
              </span>
              </label>
              <label class="form__label form__label-checkbox form__label-checkbox--locked">
                <input
                  type="checkbox"
                  v-model="consentPersonalData"
                  disabled
                  required
                >
                <div class="form__checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                    <path d="M1 5L4.33333 8.5L11 1.5" stroke="white" stroke-width="2" stroke-linecap="round"></path>
                  </svg>
                </div>
                <div class="form__text">
                  Я ознакомился с <a href="https://www.mars.com/privacy-policy-russian" class='accent' target="_blank">Положением о конфиденциальности</a>, <a href="/static/docs/Правила Акции ШОВ 2026.pdf" class='accent' target="_blank">Правилами Акции</a>, даю свое согласие на обработку <a href='/static/docs/Согласие на обработку персональных данных 2026 ШОВ.pdf' class='accent' target="_blank">персональных данных</a> и подтверждаю, что мне исполнилось 18 лет
                </div>
              </label>
              <label class="form__label form__label-checkbox">
                <input
                  type="checkbox"
                  v-model="consentMarketing"
                >
                <div class="form__checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                    <path d="M1 5L4.33333 8.5L11 1.5" stroke="white" stroke-width="2" stroke-linecap="round"></path>
                  </svg>
                </div>
                <div class="form__text">
                  Я&nbsp;даю <a href='/static/docs/Согласие на получение новостной и рекламной рассылки 2026.pdf' class='accent' target="_blank">согласие на получение новостной и рекламной рассылки</a> посредством электронных писем.
                </div>
              </label>
              <button
                @click.prevent="submitForm"
                :disabled="!canSubmit || isSubmitting"
                class="btn form__btn"
                type="button"
              >
                {{ isSubmitting ? 'ОТПРАВЛЯЕМ...' : 'ОТПРАВИТЬ' }}
              </button>

              <!-- Display general error message if any -->
              <div
                v-if="errorMessage"
                class="form__error-message"
              >
                <p class="form__error-text">{{ errorMessage }}</p>
              </div>
            </form>
          </div>
        </div>

        <div
          v-if="showSuccessMessage && !showAlreadyRegisteredModal"
          class="quiz-end"
        >
          <div class="quiz-end-top">
            <div class="quiz-end-top__img quiz-end-top__img--no-back"><img src="/static/img/avatar/happy.png" alt="зоозавр"></div>

            <h2 class="quiz-end-top__title">Спасибо!</h2>

            <p class="quiz-end-top__text quiz-end-top__text-bold">
              Отправили
              <span class='accent'>Сертификат и промокоды</span>
              на Вашу электронную почту.
            </p>

            <br><br>
            <p class="quiz-end-top__text quiz-end-top__text-bold">
              Порадуйте своего питомца
              <span class='accent'>приятными покупками!</span>
              <br>
              Ознакомиться с ассортиментом для {{ petTypeText }}, участвующим в Акции, можно на сайте 
              <a :href="petTypeUrl" target="_blank" class="accent underlined">Зоозавра</a>
            </p>

            <br><br>

            <p class="quiz-end-top__text">
              А если хотите пройти еще одно обучение, переходите по
              <a class='accent underlined' @click="returnToMain">
                ссылке
              </a>
              и выбирайте другой вид питомца
            </p>

            <br><br>

            <button
              @click="returnToMain"
              class="btn quiz-end-top__btn"
            >
              Вернуться на главную
            </button>
          </div>
        </div>
      </div>
    </main>

    <div
      v-if="showAlreadyRegisteredModal || errorMessage"
      class="modal modal--answer active"
    >
      <div class="modal-overlay"></div>
      <div class="modal-content">
        <div class="modal-content__block">
          <div class="modal-content__avatar"><img src="/static/img/avatar/default.png" alt=""></div>
          <div
              class="modal-content__answer modal-content__quiz-end"
              :class="{'modal-content__quiz-end--error' : errorMessage }"
          >

            <p class="modal-content__text" v-if="errorMessage">Извините, произошла ошибка отправки данных. Попробуйте отправить данные еще раз или пройдите обучение занова.</p>
            <div
                v-if="errorMessage"
                class="modal-content__buttons"
            >
              <button
                  @click="retryForm"
                  class="btn"
              >
                Попробовать снова
              </button>
              <button
                  @click="returnToMain"
                  class="btn"
              >
                Вернуться на главную
              </button>
            </div>

            <p class="modal-content__text" v-if="!errorMessage">Ранее Вы уже проходили данное обучение.</p>
            <p class="modal-content__text" v-if="!errorMessage">
              Но Вы можете пройти обучение по другому питомцу. Пожалуйста, передите по
              <button
                @click="returnToMain"
                class='accent underlined'
              >
                ссылке
              </button>
            </p>
          </div>
          <div
              v-if="!errorMessage"
              class="modal-content__buttons"
          >
            <button
              @click="returnToMain"
              class="btn"
            >
              Перейти по ссылке
            </button>
          </div>
        </div>
      </div>
    </div>

    <FooterComponent />
  </div>

</template>

<script>

import HeaderComponent from './Header/HeaderComponent.vue'
import FooterComponent from './Footer/FooterComponent.vue'
import { getOrCreateDeviceUUID } from '@/utils/uuid'

export default {
  name: 'QuizCompletionPage',
  props: {
    mindboxData: {
      type: Object,
      required: true
    }
  },
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      isSubmitting: false,
      showSuccessMessage: false,
      errorMessage: '',
      userName: '',
      userEmail: '',
      consentPersonalData: true,
      consentMarketing: true,
      nameError: '',
      emailError: '',
      nameValidationTimeout: null, // Для debounce валидации имени
      isValidatingName: false, // Флаг процесса валидации
      showAlreadyRegisteredModal: false // Модальное окно для "уже регистрировались"
    }
  },
  computed: {
    clientTypeText() {
      return this.mindboxData.typePet === 'Кошка' ? 'Котовладелец' : 'Собаковладелец';
    },

    petTypeText() {
      return this.mindboxData.typePet === 'Кошка' ? 'кошек' : 'собак';
    },

    petTypeUrl() {
      return this.mindboxData.typePet === 'Кошка' 
        ? 'https://zoozavr.ru/catalog/index/name/rcstmcats15_zoo_action' 
        : 'https://zoozavr.ru/catalog/index/name/rcstmdogs15_zoo_action/';
    },

    // Проверяем что имя валидно (и не пустое)
    isValidName() {
      const name = this.userName.trim();
      if (!name || name.length < 2) return false;
      if (name.length > 15) return false;

      const nameRegex = /^[а-яёА-ЯЁa-zA-Z\s\-']+$/;
      if (!nameRegex.test(name)) return false;

      // Дополнительные проверки
      if (/(.)\1{3,}/.test(name)) return false;
      if (/\s{3,}/.test(name)) return false;
      if (name.replace(/\s/g, '').length === 1) return false;

      return true;
    },

    // Проверяем что email валиден (и не пустой)
    isValidEmail() {
      const email = this.userEmail.trim();
      if (!email) return false;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) return false;

      // Дополнительные проверки
      if (email.includes('..')) return false;
      if (email.includes(' ')) return false;

      return true;
    },

    isFormValid() {
      return this.isValidName &&
             this.isValidEmail &&
             this.consentPersonalData &&
             !this.nameError &&
             !this.emailError;
    },

    canSubmit() {
      return this.isFormValid && !this.isSubmitting;
    }
  },
  watch: {
    // Реактивная валидация имени с использованием API
    userName(newValue) {
      // Очищаем предыдущий таймаут
      if (this.nameValidationTimeout) {
        clearTimeout(this.nameValidationTimeout);
      }

      // Сбрасываем ошибки
      this.nameError = '';
      this.errorMessage = ''; // Очищаем общую ошибку
      this.isValidatingName = false;

      // Если поле пустое - не валидируем
      if (!newValue) {
        return;
      }

      // Быстрые клиентские проверки (без API)
      const name = newValue.trim();

      if (!name) {
        this.nameError = 'Обязательное поле для заполнения';
        return;
      }

      if (name.length < 2) {
        this.nameError = 'Имя должно содержать минимум 2 символа';
        return;
      }

      if (name.length > 15) {
        this.nameError = 'Имя не может содержать более 15 символов';
        return;
      }

      const nameRegex = /^[а-яёА-ЯЁa-zA-Z\s\-']+$/;
      if (!nameRegex.test(name)) {
        this.nameError = 'Имя может содержать только буквы, пробелы, дефисы и апострофы';
        return;
      }

      // Дополнительные проверки
      if (/(.)\1{3,}/.test(name)) {
        this.nameError = 'Имя не может содержать более 3 одинаковых символов подряд';
        return;
      }

      if (/\s{3,}/.test(name)) {
        this.nameError = 'Имя не может содержать более 2 пробелов подряд';
        return;
      }

      if (name.replace(/\s/g, '').length === 1) {
        this.nameError = 'Имя слишком короткое';
        return;
      }

      // Если базовые проверки прошли, устанавливаем задержку для API вызова (debounce)
      this.nameValidationTimeout = setTimeout(async () => {
        await this.validateNameWithAPI(newValue);
      }, 500); // 500ms задержка
    },

    // Реактивная валидация email
    userEmail(newValue) {
      this.emailError = '';
      this.errorMessage = ''; // Очищаем общую ошибку

      // Если поле пустое - не показываем ошибку сразу
      if (!newValue) {
        return;
      }

      const email = newValue.trim();

      // Если после trim пустое
      if (!email) {
        this.emailError = 'Обязательное поле для заполнения';
        return;
      }

      // Проверка максимальной длины
      if (email.length > 254) {
        this.emailError = 'Email слишком длинный';
        return;
      }

      // Базовая проверка формата email - используем более простое сообщение как на макете
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.emailError = 'Неверный адрес электронной почты';
        return;
      }

      // Дополнительные проверки
      if (email.includes('..')) {
        this.emailError = 'Неверный адрес электронной почты';
        return;
      }

      if (email.includes(' ')) {
        this.emailError = 'Неверный адрес электронной почты';
        return;
      }
    }
  },
  mounted() {
    // Отслеживаем посещение страницы завершения квиза
    this.sendEventYM(
      'step6_successful_completion'
    );

    // Проверяем, была ли форма успешно отправлена
    const formSubmitted = localStorage.getItem('form_submitted_successfully');
    
    if (formSubmitted === 'true') {
      // Если форма была отправлена, сбрасываем прогресс и флаги
      localStorage.removeItem('completion_form_reached');
      localStorage.removeItem('form_submitted_successfully');
      const key = `courseProgress_${getOrCreateDeviceUUID()}`;
      if (key) {
        localStorage.removeItem(key);
      }
      // Перенаправляем на главную
      this.$router.push('/');
      return;
    }

    // Устанавливаем флаг что пользователь дошел до формы заполнения
    localStorage.setItem('completion_form_reached', 'true');

    // Проверяем, не проходил ли пользователь уже обучение
    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';
    const deviceUuid = getOrCreateDeviceUUID();

    // Асинхронная проверка
    fetch(`${API_BASE_URL}/api/mindbox/check`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: '', // Пустой email для проверки
        name: '', // Пустое имя для проверки
        pet_type: this.mindboxData.typePet,
        device_uuid: deviceUuid
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'AlreadyRegistered') {
        // Если пользователь уже проходил обучение, показываем модальное окно
        this.showAlreadyRegisteredModal = true;
        // Очищаем прогресс и флаги только если пользователь уже регистрировался
        localStorage.removeItem('completion_form_reached');
        localStorage.removeItem('form_submitted_successfully');
        const key = `courseProgress_${deviceUuid}`;
        if (key) {
          localStorage.removeItem(key);
        }
      }
      // В остальных случаях оставляем флаг completion_form_reached и прогресс
    })
    .catch(() => {
      // В случае ошибки оставляем флаг completion_form_reached и прогресс
      // Не очищаем данные, чтобы пользователь остался на странице формы
    });
  },
  methods: {
    goBack() {
      this.$emit('go-back');
    },

    async submitForm() {
      // Финальная валидация перед отправкой
      this.validateNameOnBlur();
      this.validateEmailOnBlur();

      if (!this.canSubmit) {
        return;
      }

      this.isSubmitting = true;
      this.errorMessage = '';

      try {
        // Отправляем данные в Mindbox
        const result = await this.sendToMindbox();

        // Проверяем результат отправки
        if (result && result.success) {
          // Показываем успешное сообщение только при реальном успехе
          this.showSuccessMessage = true;
          
          // Устанавливаем флаг успешной отправки формы
          localStorage.setItem('form_submitted_successfully', 'true');
          
          // Очищаем прогресс из localStorage
          const key = `courseProgress_${getOrCreateDeviceUUID()}`;
          if (key) {
            localStorage.removeItem(key);
          }
        } else if (result && result.error === 'validation_error') {
          // Ошибки валидации уже обработаны в handleValidationErrors
          // Не показываем успешное сообщение
        } else if (result && result.error === 'already_registered') {
          // Модальное окно уже показано в sendToMindbox
          // Не показываем успешное сообщение
        } else {
          // Неизвестная ошибка
          this.errorMessage = 'Произошла неизвестная ошибка при отправке данных';
        }

        this.sendEventYM(
          'send_certificate_click_btn'
        );

      } catch (error) {
        this.errorMessage = error.message || 'Произошла ошибка при отправке данных';
      } finally {
        this.isSubmitting = false;
      }
    },

    async sendToMindbox() {
      const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';
      let deviceUuid = getOrCreateDeviceUUID(); // Используем утилиту

        // First, check if user can be registered
        const checkResponse = await fetch(`${API_BASE_URL}/api/mindbox/check`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.userEmail,
            name: this.userName,
            pet_type: this.mindboxData.typePet,
            device_uuid: deviceUuid
          })
        });

        if (!checkResponse.ok) {
          // Обработка ошибок валидации (422)
          if (checkResponse.status === 422) {
            const errorData = await checkResponse.json();
            this.handleValidationErrors(errorData);
            return { success: false, error: 'validation_error' }; // Возвращаем ошибку валидации
          }
          throw new Error(`Check failed: ${checkResponse.status}`);
        }

        const checkData = await checkResponse.json();

        // Handle different status cases
        if (checkData.status === 'AlreadySubmitted') {
          throw new Error('Вы уже отправляли данные для этого типа питомца');
        }

        if (checkData.status === 'AlreadyRegistered') {
          this.showAlreadyRegisteredModal = true;
          return { success: false, error: 'already_registered' }; // Возвращаем специальный статус
        }

        if (!checkData.can_register) {
          throw new Error('Пользователь не может быть зарегистрирован в системе Mindbox');
        }

        // If check passed, submit the data
        const submitResponse = await fetch(`${API_BASE_URL}/api/mindbox/submit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.userEmail,
            name: this.userName,
            pet_type: this.mindboxData.typePet,
            type_client: this.mindboxData.typeClient,
            device_uuid: deviceUuid,
            consents: {
              personalData: this.consentPersonalData,
              marketing: this.consentMarketing
            }
          })
        });

        if (!submitResponse.ok) {
          // Обработка ошибок валидации при submit
          if (submitResponse.status === 422) {
            const errorData = await submitResponse.json();
            this.handleValidationErrors(errorData);
            return { success: false, error: 'validation_error' };
          }
          throw new Error(`Submit failed: ${submitResponse.status}`);
        }

        const submitData = await submitResponse.json();

        if (!submitData.success) {
          if (submitData.status === 'AlreadySubmitted') {
            throw new Error('Данные уже были отправлены ранее');
          }
          throw new Error(submitData.message || 'Ошибка отправки данных');
        }

        // После успешной отправки в Mindbox, генерируем сертификат
        await this.generateCertificate(deviceUuid);

        return { success: true };
    },

    async generateCertificate(deviceUuid) {
      const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

      try {

        const certificateResponse = await fetch(`${API_BASE_URL}/api/certificate/generate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.userEmail,
            name: this.userName,
            pet_type: this.mindboxData.typePet,
            device_uuid: deviceUuid
          })
        });

        if (!certificateResponse.ok) {
          return; // Не прерываем весь процесс, если сертификат не сгенерировался
        }

        const certificateData = await certificateResponse.json();

        if (certificateData.success) {
          // Можно показать пользователю сообщение о том, что сертификат отправлен на email
        }

      } catch (error) {
        // Не прерываем весь процесс, если сертификат не сгенерировался
      }
    },
    handleValidationErrors(errorData) {
      // Обработка ошибок валидации Pydantic (422)

      // Сбрасываем предыдущие ошибки
      this.nameError = '';
      this.emailError = '';

      if (errorData && errorData.detail && Array.isArray(errorData.detail)) {
        errorData.detail.forEach(error => {
          const field = error.loc[error.loc.length - 1]; // Последний элемент в loc - это имя поля
          const message = error.msg;

          if (field === 'name') {
            this.nameError = message;
          } else if (field === 'email') {
            this.emailError = message;
          }
        });
      }
    },
    returnToMain(e) {
      // Предотвращаем стандартное поведение только для ссылок
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      
      // Очищаем флаги при возврате на главную
      localStorage.removeItem('completion_form_reached');
      localStorage.removeItem('form_submitted_successfully');
      
      // Очищаем прогресс из localStorage
      const key = `courseProgress_${getOrCreateDeviceUUID()}`;
      if (key) {
        localStorage.removeItem(key);
      }

      // Эмитим событие к родительскому компоненту QuizPage
      this.$emit('return-to-main');
    },

    async validateNameWithAPI(name) {
      if (!name || !name.trim()) {
        return;
      }

      const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';
      this.isValidatingName = true;

      try {
        const response = await fetch(`${API_BASE_URL}/api/validate/name`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: name
          })
        });

        if (response.ok) {
          const result = await response.json();

          if (!result.is_valid && result.error_message) {
            this.nameError = result.error_message;
          } else {
            this.nameError = '';
          }
        }
      } catch (error) {
        // Не показываем ошибку пользователю при проблемах с сетью
      } finally {
        this.isValidatingName = false;
      }
    },
    closeAlreadyRegisteredModal() {
      this.showAlreadyRegisteredModal = false;
    },
    goToOtherPetCourse() {
      // Закрываем модальное окно
      this.showAlreadyRegisteredModal = false;

      // Очищаем флаги при переходе к другому питомцу
      localStorage.removeItem('completion_form_reached');
      localStorage.removeItem('form_submitted_successfully');
      
      // Очищаем прогресс из localStorage
      const key = `courseProgress_${getOrCreateDeviceUUID()}`;
      if (key) {
        localStorage.removeItem(key);
      }

      // Переходим на главную страницу для выбора другого курса
      this.$router.push('/');
    },
    validateNameOnBlur() {
      const name = this.userName.trim();
      if (!name) {
        this.nameError = 'Обязательное поле для заполнения';
      }
      if (name.length > 15) {
        this.nameError = 'Имя не может содержать более 15 символов';
      }
    },
    validateEmailOnBlur() {
      const email = this.userEmail.trim();
      if (!email) {
        this.emailError = 'Обязательное поле для заполнения';
        return;
      }

      // Выполняем полную валидацию email при потере фокуса
      // Проверяем формат
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.emailError = 'Неверный адрес электронной почты';
        return;
      }

      // Если все проверки прошли, очищаем ошибку
      this.emailError = '';
    },
    retryForm() {
      // Скрываем модальное окно с ошибкой
      this.errorMessage = '';
      
      // Сбрасываем состояние отправки
      this.isSubmitting = false;
      
      // Очищаем ошибки валидации полей
      this.nameError = '';
      this.emailError = '';
      
      // Форма остается заполненной, пользователь может изменить данные и попробовать снова
      // Прогресс пользователя сохраняется, так как мы не очищаем localStorage
    }
  }
}
</script>

<style scoped lang="scss">
.quiz-end {
  margin-inline: auto;
  max-width: 700px;
}

.quiz-end-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 29px;

  &__img {
    position: relative;
    margin-top: 32px;
    margin-bottom: 32px;
    background-image: url("/static/img/game-end-background.svg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;

    &.quiz-end-top__img--no-back {
      background-image: none;
    }

    & img {
      max-height: 141px;
    }
  }

  &__title {
    @include h1;

    margin-bottom: 24px;
    color: var(--dark-gray, #585858);
    text-align: center;
  }

  &__accent {
    @include h2;

    font-weight: 700;
    margin-bottom: 24px;
    color: var(--red, #EC001A);
    text-align: center;
  }

  &__text {
    @include p-option;

    color: var(--dark-gray, #585858);
    font-weight: 400;
    line-height: 1.23;
    text-align: center;

    &.quiz-end-top__text-bold {
      font-weight: 700;
    }
  }

  &__btn {
    margin-inline: auto;
    max-width: 700px;
    width: 100%;
  }
}

.quiz-end-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 32px;

  & form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  & .form {
    &__label {
      display: flex;
      flex-direction: column;
      margin-bottom: 32px;

      // поля с чекбоксами
      &-checkbox {
        position: relative;
        flex-direction: row;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 7px;

        & input {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
          pointer-events: none;
        }

        & .form__checkbox {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          width: 18px;
          height: 18px;
          border-radius: 4px;
          border: 1px solid rgba(170, 170, 170, 0.5);
          transition: $duration $timing-function;

          svg {
            opacity: 0;
            transition: $duration $timing-function;
          }
        }

        & .form__text {
          line-height: 1.2;
          font-weight: 300;
          color: var(--dark-gray);

          & a.accent {
            font-weight: 700;
          }
        }

        input[type="checkbox"]:checked + .form__checkbox {
          background-color: var(--red);
          border-color: var(--red);
          opacity: 1;

          svg {
            opacity: 1;
          }
        }

        &--locked {
          cursor: default;

          & .form__checkbox {
            opacity: 0.7;
          }
        }
      }

      //ошибка
      &.error {
        & .form__input {
          margin-bottom: 10px;
          color: var(--red);
          border-color: var(--red);
        }

        & .error__message {
          font-size: 12px;
          font-weight: 400;
          line-height: 1;
          color: var(--red);
        }
      }
    }

    &__text {
      @include text-16-500;

      font-weight: 500;
      margin-bottom: 8px;
      color: var(--black);

      &.quiz-end-top__text-bold {
        font-weight: 500;
      }
    }

    &__input {
      @include text-16-500;

      font-weight: 400;
      padding-bottom: 9px;
      color: var(--black);
      border-bottom: 1px solid rgba(170, 170, 170, 0.5);

      &::placeholder {
        color: var(--gray);
      }
    }

    &__btn {
      margin-top: 16px;
      margin-bottom: 32px;
    }

    &__error-message {
      margin-top: 16px;
      padding: 12px;
      background-color: #f8d7da;
      border: 1px solid #f5c6cb;
      border-radius: 6px;
      text-align: center;
    }

    &__error-text {
      @include text-16-500;
      color: #721c24;
      margin: 0;
      font-weight: 400;
    }
  }
}

</style>
